module.exports = __webpack_public_path__ + "media/img/pages/companies/safran-1e89de6fa4e4dd8bbce6154f378d0c49.png";